module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d61429ad96a25ec2917ebc77d900aae0.svg";